export default __webpack_public_path__ + "static/media/fish-and-chips.6a6f39f3.jpg";